import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export default function ModalWrapper({
  children,
  isModalOpen,
  toggleModal,
  title = '',
  onButtonClick = null,
  size = 'lg',
}) {
  const modalContentStyle = {
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '14px',
  };

  const modalBodyStyle = {
    overflowY: 'auto',
    flex: 1,
    padding: '0',
  };

  return (
    <Modal isOpen={isModalOpen} toggle={toggleModal} centered size={size}>
      <ModalHeader className="p-3 border-bottom" toggle={onButtonClick}>
        <span className="fs-5 fw-semibold">{title}</span>
      </ModalHeader>
      <div style={modalContentStyle}>
        <ModalBody style={modalBodyStyle}>{children}</ModalBody>
      </div>
    </Modal>
  );
}
